module.exports = __webpack_public_path__ + "static/media/driver-step-icon-white.b29045d2.svg";